import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import SentryErrorBoundary from '../SentryErrorBoundary';

const SurveyAnswerPage = Loadable(lazy(() => import('views/surveys/survey-answer')));
const DownloadSurveyAnswer = Loadable(lazy(() => import('views/shared/download-survey-answer')));

const PrivateRespondentSurvey = Loadable(lazy(() => import('views/shared/answer-respondent-survey')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const childRoutes = [
  {
    path: '/surveys/:surveyTypeUID',
    element: <SurveyAnswerPage />
  },
  {
    path: '/surveys/survey/:surveyUID',
    element: <SurveyAnswerPage />
  },
  {
    path: '/surveys/:surveyId/download',
    element: <DownloadSurveyAnswer />
  },
  {
    path: '/surveys/m/:surveyUid',
    element: <PrivateRespondentSurvey isMagicLink />
  }
];

const SurveyRoutes = {
  path: '/',
  element: <MinimalLayout />,
  errorElement: <SentryErrorBoundary />,
  children: childRoutes
};

export default SurveyRoutes;
